import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { http } from '../../services/HttpInterceptor';
import {
    RouteComponentProps, Link, Redirect
} from "react-router-dom";
import { toast } from 'react-toastify';
import { observable } from 'mobx';
import InputForm from '../site/layout/InputForm';
import { sessionService } from '../../services/SessionService';

interface NewMobilePaymentProps extends RouteComponentProps {
    changeToggle(action?: boolean): void
}

@observer export default class NewMobilePayment extends React.Component<NewMobilePaymentProps> {

    @observable private mobilePayment: any = {
        name: "",
        description: ""
    };
    @observable private redirect = false;
    @observable private validationErrors: string[] = [];

    componentDidMount() {
        this.props.changeToggle(true);
    }

    private handleChange = (event: any) => {
        const { name, value } = event.target;
        this.mobilePayment[name] = value;
    }

    private setValidation = (value: boolean, name: string): void => {
        const error = this.validationErrors.indexOf(name);
        if (value && error === -1) {
            this.validationErrors.push(name);
        } else if (!value && error !== -1) {
            this.validationErrors.splice(error, 1);
        }
    }

    private onSubmit = (): void => {
        this.mobilePayment.created_by = sessionService.getUserInfo().id;

        if (this.validationErrors.length > 0) {
            toast.error("Hay un error en tu formulario");
            return;
        }

        http.post(`/api/mobile_payments/create`, JSON.stringify(this.mobilePayment))
            .then(() => {
                toast.success(`Método de pago móvil agregado`);
                this.redirect = true;
            }).catch((error) => {
                if (Array.isArray(error)) {
                    error.forEach((val) => {
                        toast.error(val);
                    })
                } else {
                    toast.error(error);
                }
            });
    }

    render() {
        if (this.redirect) {
            return <Redirect to="/pagos-movil" />
        }
        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header card-header-rose card-header-text">
                                <div className="card-text">
                                    <h4 className="card-title">Nuevo Método de Pago Móvil</h4>
                                </div>
                            </div>
                            <div className="card-body ">
                                <div className="row">
                                    <div className="col-sm-10"></div>
                                    <div className="col-sm-2">
                                        <Link to={`/pagos-movil`}>
                                            <button className="btn btn-danger btn-sm  pull-right">
                                                <i className="material-icons">highlight_off</i>
                                                <div className="ripple-container"></div>
                                            </button>
                                        </Link>
                                    </div>
                                </div>
                                <InputForm
                                    name="name"
                                    label="Nombre del Método de Pago"
                                    value={this.mobilePayment.name}
                                    setValidation={this.setValidation}
                                    required={true}
                                    onChange={this.handleChange}
                                    type="text"
                                />
                                <div className="row">
                                    <label className="col-sm-2 col-form-label">Descripción</label>
                                    <div className="col-sm-10">
                                        <div className="form-group bmd-form-group">
                                            <textarea
                                                className="form-control"
                                                name="description"
                                                rows={4}
                                                value={this.mobilePayment.description}
                                                onChange={this.handleChange}
                                                placeholder="Ej: Depósito a tarjeta 1234 5678 9012 3456, Banco XYZ, CLABE: 123456789012345678"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <button onClick={this.onSubmit} type="submit" className="btn btn-primary pull-right">Agregar Método de Pago</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment >
        )
    }
}

